// extracted by mini-css-extract-plugin
export var assigneeBadge = "_hi-0";
export var assigneeDetails = "_hi-1";
export var assigneeInfo = "_hi-2";
export var dropdownContainer = "_hi-4";
export var dropdownImage = "_hi-5";
export var editAssigneeInfo = "_hi-3";
export var editAssigneeModalContainer = "_hi-6";
export var hidden = "_hi-8";
export var input = "_hi-7";